
const state = {
    hidden: true,
    collapse: true,
    darkMode: false,
    searchType: 'full',
    isMenuOpen: false,
    singleSearch: {
        type: null,
        query: ''
    },
}

const getters = {
    isSingleSearch(state) {
        return state.searchType === 'single'
    },
    isFullSearch(state) {
        return state.searchType === 'full'
    },
    isResultSearch(state) {
        return state.searchType === 'result'
    },
    isHidden(state) {
        return state.hidden
    }
}

const actions = {
    toggleFullMenu({ commit }) {
        return commit('toggleMenu')
    },
    darkMode({ commit}) {
        commit('toggleDarkMode')
    },
    setCollapse({ commit}, collapse) {
        commit('setCollapse', collapse)
    },
    setHidden({ commit }, hidden) {
        commit('setHidden', hidden)
    },
    setType({ commit}, type) {
        commit('setType', type)
    },
    enableSingleSearch({ commit, state }, type) {
        commit('setSingleSearch', true)
    },
    disableSingleSearch({ commit }) {
        //commit('setSingleSearch', false)
        commit('clearSingleSearch')
    },
    enableResultPage({ commit, state, dispatch }) {
        commit('setHidden', false);
        commit('setCollapse', false)
        commit('setResultPage')
        commit('search/enableAutoComplete', false, {root: true})
    },
    disableResultPage({ commit, state, dispatch }) {
        commit('setHidden', true);
        commit('setCollapse', true);
        commit('setFullSearch');
        commit('search/enableAutoComplete', true, {root: true})
    },
    updateQuery({ commit, state }, search) {
        commit('setQuery', search)
    },
    clearQuery({ commit }) {
        commit('setQuery', '')
    },
    resetAllSearch({ commit, state, dispatch}) {
        dispatch('search.clearSearch')
        dispatch('search.closeSearch')
        commit('clearSingleSearch')
        commit('toggleMenu')
    }
}

const mutations = {
    openMenu(state) {
        document.querySelector('body').style.overflow = 'hidden';
        state.isMenuOpen = true;
    },
    closeMenu(state) {
        document.querySelector('body').style.overflow = '';
        state.isMenuOpen = false;
    },
    toggleDarkMode(state) {
        state.darkMode = !state.darkMode
        if (state.darkMode) {
            document.body.classList.add('dark');
        } else {
            document.body.classList.remove('dark');
        }
    },
    enableDarkMode(state) {
        if(!state.darkMode) {
            document.body.classList.add('dark');
            state.darkMode = true
        }
    },
    disableDarkMode(state) {
        if (state.darkMode) {
            document.body.classList.remove('dark');
            state.darkMode = false
        }
    },
    setCollapse(state, collapse) {
        state.collapse = collapse
    },
    setHidden(state, hidden) {
        state.hidden = hidden
    },
    setType(state, type) {
        state.singleSearch.type = type
    },
    setSingleSearch(state, enable, type) {
        state.searchType = 'single'
        //state.singleSearch.type = type
    },
    setResultPage(state) {
        state.searchType = 'result'
    },
    setFullSearch(state) {
        state.searchType = 'full'
    },
    setQuery(state, query) {
        state.singleSearch.query = query
    },
    clearSingleSearch(state) {
        state.searchType = 'full'
        state.singleSearch.type = null
        state.singleSearch.query = ''
    }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
